/**
 * Chi tiêu / Thu nhập as two tappable cards — the layout the PO asked for on 2026-08-19,
 * following the app the family already uses: the two figures of the month are also the switch
 * that decides which breakdown is drawn below them.
 *
 * Real tabs, not two buttons that look like tabs: `role="tablist"` + `aria-selected` is what
 * tells a screen reader that tapping one changes the panel underneath.
 */
import { cx } from '../../../shared/lib/cx.js';
import { formatVnd } from '../../../shared/lib/money.js';
import styles from './SummaryTabs.module.css';

export type SummaryTab = 'expense' | 'income';

export function SummaryTabs({
  active,
  expenseTotal,
  incomeTotal,
  panelId,
  onChange,
}: {
  active: SummaryTab;
  expenseTotal: number;
  incomeTotal: number;
  /** The breakdown card this pair controls. */
  panelId: string;
  onChange: (tab: SummaryTab) => void;
}) {
  const tabs: ReadonlyArray<{ id: SummaryTab; label: string; icon: string; amount: number }> = [
    { id: 'expense', label: 'Chi tiêu', icon: '↗', amount: expenseTotal },
    { id: 'income', label: 'Thu nhập', icon: '↙', amount: incomeTotal },
  ];

  return (
    <div className={styles.tabs} role="tablist" aria-label="Chi tiêu hay thu nhập">
      {tabs.map((tab) => (
        <button
          key={tab.id}
          type="button"
          role="tab"
          aria-selected={active === tab.id}
          aria-controls={panelId}
          className={cx(styles.tab, active === tab.id && styles.tabActive)}
          onClick={() => onChange(tab.id)}
        >
          <span className={styles.label}>
            <span className={styles.labelIcon} aria-hidden="true">
              {tab.icon}
            </span>
            {tab.label}
          </span>
          <span className={styles.amount}>{formatVnd(tab.amount)}</span>
        </button>
      ))}
    </div>
  );
}
